import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {TerminalModel} from '../models/terminal.model';
import {environment} from "../../environments/environment";
import {Pagination} from "../shared/interfaces/pagination";
import {PaginatedResponse} from "../models/paginated-response";
import {OrganizationModel} from "../models/organization.model";
import {TractorModel} from "../models/tractor.model";
import {TrailerCreator} from "../models/trailer.creator";
import {catchError, map} from "rxjs/operators";

export interface TerminalsFilter {
  organizationId?: number;
}

@Injectable()
export class TerminalDataSource {

  constructor(
    private http: HttpClient
  ) { }

  getAllTerminals(pagination: Pagination = {},  terminalsFilters?: TerminalsFilter): Observable<PaginatedResponse<TerminalModel>> {
    const params = {};
    if (pagination?.pageNumber) {
      params['pageNumber'] = pagination.pageNumber;
    }

    if (pagination?.removeLimit) {
      params['removeLimit'] = pagination.removeLimit;
    }

    if (pagination?.pageSize) {
      params['pageSize'] = pagination.pageSize;
    }

    if (terminalsFilters?.organizationId) {
      params['organizationId'] = terminalsFilters.organizationId;
    }
    return this.http.get<PaginatedResponse<TerminalModel>>(
      environment.backendApi + 'api/Terminals',
      {params}
    );
  }

  getTerminals(organizationId: number): Observable<TerminalModel[]> {
    return this.http.get<TerminalModel[]>(environment.backendApi + 'api/Terminals/GetTerminals/' + organizationId);
  }

  delete(terminalId: number): Observable<void> {
    return this.http.delete<void>(environment.backendApi + `api/Terminals/${terminalId}`);
  }

  create(body: Partial<TerminalModel>) {
    return this.http.post<TerminalModel>(environment.backendApi + 'api/Terminals', body);
  }

  update(id: number, body: Partial<TerminalModel>) {
    return this.http.put<TerminalModel>(environment.backendApi + `api/Terminals/${id}`, body);
  }
}

